import {createReducer, on} from "@ngrx/store";
import {FiusActions} from "../actions";
import {FiuDto} from "@esa/api";
import {EnumDetailDto} from "@esa/api/models/EnumDetailDto";

export const fiusFeatureKey = 'fius';

export interface FiusState {
  fius: FiuDto[];
  totalRecords: number;
  selectedFiu: FiuDto;
  fiuStatuses: EnumDetailDto[];
  fiuList: FiuDto[];
}

const initialState: FiusState = {
  fius: [],
  totalRecords: 0,
  selectedFiu: null,
  fiuStatuses: [],
  fiuList: [],
};

export const fiusReducer = createReducer(
  initialState,
  on(FiusActions.getFiusSuccess, (state, { fius, totalRecords }) => ({ ...state, fius, totalRecords, selectedFiuId: '', selectedFiu: null })),
  on(FiusActions.setSelectedFiu, (state, { selectedFiu }) => ({ ...state, selectedFiu })),
  on(FiusActions.updateFiuSuccess, (state) => ({ ...state, selectedFiu: null})),
  on(FiusActions.archiveFiuSuccess, (state) => ({ ...state, selectedFiu: null })),
  on(FiusActions.getFiuStatusesSuccess, (state, { fiuStatuses }) => ({ ...state, fiuStatuses })),
  on(FiusActions.getFiuListSuccess, (state, { fiuList }) => ({ ...state, fiuList })),
  on(FiusActions.activateFiuSuccess, (state) => ({ ...state, selectedFiu: null }))
);
